<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h2 class="h4 no-margin-bottom">Kullanıcı Yetkilendirme</h2>
       <div class="right-menu list-inline no-margin-bottom">
          <router-link to="/liste/kullanici"><button type="submit" class="btn submit bg-dark text-light">Liste</button>
          </router-link>
       </div>
      </div>
    </div>

        <section class="no-padding-top">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 block">
                <span>Kayıt Yetkilendirmesi Servis işlem menüsü ve yetkili kullanıcılariçin geçerlidir.</span>
              </div>
            </div>
            <div v-if="tip==1 || tip ==2 || tip==6"  class="row">
              <!-- Basic Form-->
              <div class="col-lg-4">
                <div class="block">
                  <div v-for="post in sol" :key="post.id">
                      <button class="btn btn-lg btn-outline-info d-block w-100 mb-4" @click="yetkiver(post.id)">{{post.alias}}</button>
                  </div>
                </div>
              </div>
              <!-- Horizontal Form-->
              <div class="col-lg-8">
                <div class="block">
                  <div class="table-responsive"> 
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Tip</th>
                          <th>Kodu</th>
                          <th>Alias</th>
                          <th>Kaldır</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="post in posts" :key="post.id">
                          <td>{{post.valuesi}}</td>
                          <td>{{talias}}</td>
                          <td>{{post.ad_soyad}}</td>
                          <td>{{post.alias}}</td>
                          <td @click="yetkial(post.valuesi,parametre,kid)">Geri al</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>
            <div class="row">
              <div class="col-12 block">
                <span>Sayfa Yetkilendirmesi tüm kullanıcılar için geçerlidir.</span>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4">
                <div class="block">
                  <div v-for="post in sol2" :key="post.id">
                      <button class="btn btn-lg btn-outline-danger d-block w-100 mb-4" @click="sayfaver(post.id)">{{post.alias}}</button>
                  </div>
                </div>
              </div>
              <!-- Horizontal Form-->
              <div class="col-lg-8">
                <div class="block">
                  <div class="table-responsive"> 
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>Tip</th>
                          <th>İsim</th>
                          <th>Alias</th>
                          <th>Kaldır</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="post in posts2" :key="post.sayfa">
                          <td>{{post.tip}}</td>
                          <td>{{post.isim}}</td>
                          <td>{{post.alias}}</td>
                          <td @click="sayfaal(post.sayfa)">Sayfa al</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        <div v-if="progres.inprogres">
          <div id="spinner-front" class="show"> <img src="/set/ajax-loader.gif"/><br>{{progres.mesaj}} ...</div>
          <div id="spinner-back" class="show"></div>
        </div>
    </div>
</template>
<script>
  export default {
    created() {
      //this.progres.inprogres = true
      this.yetki();
    },
    data() {
      return {
        url:this.$route.params.id,
        progres : {
          mesaj:'Bekleyiniz',
          inprogres:false
        } ,              
        inProgress: false,
        search: '',
        posts: [],
        posts2:[],
        errors: [],
        sol:[],
        sol2:[],
        firma:this.$request.ayar().firmaid,
        kid:'',
        tip:'',
        talias:'',
        parametre:'',
        table:''
      };
    },

    methods: {
      yetki(){
        // burada ileride bunları json a gibi tek bir blok değişken haline getirilebilirmi bakmak lazım önemli 
        if(this.$helper.sayfayetki(487002)){
        let table = ''
        let parametre = ''
        let url = this.url.split('bn')
        this.kid = url[0]/8589;
        this.tip = url[1]/8846;

        switch(url[1]/8846) {
          case 1:
              this.table = 'tbl_firma';
              this.parametre = 'fid_'
              this.getPostsAsync(this.table,this.parametre);
              this.talias = 'Sistem Yöneticisi'
            break;

          case 2:
              this.table = 'tbl_bolge';
              this.parametre = 'bid_';
              this.getPostsAsync(this.table,this.parametre);
              this.talias = 'Bölge Müdürü'
            break;

          case 6:
              this.table = 'tbl_sa';
              this.parametre = 'said_';
              this.getPostsAsync(this.table,this.parametre);
              this.talias = 'Sağlayıcı'
            break;
              default:
                this.sagaltyetki()
        }
        }
        else {
          alert('Bu alanı kullanım yetkiniz yok')
          this.$router.go(-1)
        }
      },
      getPostsAsync(table,parametre) {
        this.$request.get("servis/sagyetki/"+table+"/"+parametre+"/"+this.kid)
        .then(res => {this.posts = res.results
        this.solyetki(table);
        this.sagaltyetki()
        })
        .catch(err => {this.errors.push(err)})
      },
      sagaltyetki() {
        this.$request.get("servis/sagaltyetki/"+this.kid)
        .then(res => {this.posts2 = res.results
        this.solaltyetki()
        })
        .catch(err => {this.errors.push(err)})
      },
      solaltyetki() { 
        this.sol2 = [];
        let kontrol =false;
        let rc = {};
        this.$request.get("servis/solaltyetki/"+this.firma) // firma gönderiliyor ama backend den iptal edildi
        .then(res => {
          for (let i = 0; i < res.results.length; i++) {
            kontrol = this.bak2(res.results[i].id)
              if (kontrol){
                  rc = {
                      id:res.results[i].id,
                      alias:res.results[i].alias
                  }
                  this.sol2.push(rc)
                }
              }
        this.progres.inprogres = false
        })
        .catch(err => {this.errors.push(err)})
      },
      bak2(indexi){
        let durum = ''
          var index = this.posts2.findIndex(std=> std.sayfa === indexi);
         if (index > -1) {return false}
         else{return true}
      },
      solyetki(table) { 
        this.sol = [];
        let kontrol =false;
        let rc = {};
        this.$request.get("servis/solyetki/"+table+"/"+this.firma)
        .then(res => {
          for (let i = 0; i < res.results.length; i++) {
            kontrol = this.bak(res.results[i].id)
              if (kontrol){
                  rc = {
                      id:res.results[i].id,
                      alias:res.results[i].alias
                  }
                  this.sol.push(rc)
                }
              }
        this.progres.inprogres = false
        })
        .catch(err => {this.errors.push(err)})
      },
      bak(indexi){
        let durum = ''
          var index = this.posts.findIndex(std=> std.valuesi === indexi);
         if (index > -1) {return false}
         else{return true}
      },
      yetkiver(id){
        let postu = {
	      kid: this.kid,
        valuesi: id,
        keysi:this.parametre,
        table:'kayit_yetki'
        }
        this.$request.post("servis/userservisyetki/", postu)
        .then(res => {

          this.progres.inprogres = true
          this.getPostsAsync(this.table, postu.keysi)

        })
      },
      yetkial(deger,parametre,kid){
        this.$request.get("servis/yetkial/"+deger+"/"+parametre+"/"+kid)
        .then(res => {
          this.getPostsAsync(this.table, parametre)
          this.progres.inprogres = true
        })
      },
      sayfaal(id){
        this.$request.get("servis/sayfaal/"+id+"/"+this.kid)
        .then(res => {
          this.sagaltyetki()
          this.progres.inprogres = true
        })
      },
      sayfaver(id){
        let postu = {
	      kid: this.kid,
        sayfa: id,
        }
        this.$request.post("servis/sayfaver/", postu)
        .then(res => {
          this.progres.inprogres = true
          this.sagaltyetki()

        })
      },
    }

  };
</script>



// WEBPACK FOOTER //
// src/views/kullanici/detay.vue